import { render, staticRenderFns } from "./camposOpcionais.vue?vue&type=template&id=ac186410&"
import script from "./camposOpcionais.vue?vue&type=script&lang=js&"
export * from "./camposOpcionais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports